import { Box } from "@mui/system"
import ButtonMedium1 from "components/elements/ButtonMedium1"
import ContentNormal from "components/elements/ContentNormal"
import Headline2 from "components/elements/Headline2"
import SectionWrapper from "components/layouts/SectionWrapper"
import { AppContext } from "contexts/AppContext"
import { useContext, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { setupUserData } from "utils/setup"

export const WalletConfirmation = () => {
    const contextState = useContext(AppContext);
    const navigate = useNavigate()

    useEffect(() => {
        // Fetch user data to ensure that the wallet points are updated after returning from the payment provider
        setupUserData(contextState, () => {})
    }, [])

    return (
        <SectionWrapper sx={{minHeight: '60vh'}}>
            <Box sx={{paddingTop: 14}} display={'flex'} flexDirection={'column'} gap={4}>
                <Box display={'flex'} gap={4}>
                    <Headline2
                        translationKey="_WALLET_CONFIRMATION_"
                        fallbackText="Bekræftelse på betaling"
                    />
                </Box>
                <Box display={'flex'} flexDirection={'column'} gap={4}>
                    <ContentNormal
                        translationKey="_WALLET_CONFIRMATION_DESCRIPTION_"
                        fallbackText="Tak for din betaling. Du har nu modtaget dine point."
                    />
                    <Box>
                        <ButtonMedium1
                            showIcon={false}
                            translationKey="_GO_TO_BASKET_"
                            fallbackText={"Gå til kurven"}
                            onClick={() => navigate("/basket")}
                        />
                    </Box>
                </Box>
            </Box>
        </SectionWrapper>
    )
}

